$(".close-announcement").on("click", function (e) {
    e.preventDefault();
    $(".announcement-bar").remove();
    $(".main-content").css("padding-top", `${$('#shopify-section-header').height()}px`);
    Cookies.set("hide-announcement-banner", true);
});

// unhide top banner
var hideTopBannerCookie = Cookies.get("hide-announcement-banner");
if (
    typeof hideTopBannerCookie == "undefined" ||
    hideTopBannerCookie != "true"
) {
    $(".announcement-bar").removeClass("hidden");
    $(".main-content").css("padding-top", `${$('#shopify-section-header').height()}px`);
}


console.log(Cookies.get('hide-announcement-banner'));

$(window).on('load resize', function(){
     $(".main-content").css("padding-top", `${$('#shopify-section-header').height()}px`);
})